// extracted by mini-css-extract-plugin
export default {"shape":"Portfolio_shape__CqP95","pTable":"Portfolio_pTable__VpjJg"};